import { render, staticRenderFns } from "./commentAfter.vue?vue&type=template&id=0ad7bbdc&"
import script from "./commentAfter.vue?vue&type=script&lang=js&"
export * from "./commentAfter.vue?vue&type=script&lang=js&"
import style0 from "./commentAfter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports